import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    participanteId: 0,

    evento: {},
    participante: {},
    
    // nombre: '',
    // datos: [],
    // informacionBancaria: [],
    // negocioDatos: [],
    // codigoPromocion: [],

    validacionesIdentidad: [],
    validacionesParticipacion: [],
    transferencias: [],
    validacionIdentidadReinscripcion: [],
    etapas: [],
    imagenes: [],
    
    reinscripcion: false,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.eventoId = parseInt(params.eventoId);
        state.participanteId = parseInt(params.participanteId);

        state.evento = {};

        state.participante = {
            /* Datos del participante */
            nombreCompleto: null,
            fechaNacimiento: null,
            documentoNumero: null,
            sexo: null,
            pais: null,
            provincia: null,
            localidad: null,
            direccion: null,
            codigoPostal: null,
            numeroCelular: null,
            email: null,
            clientePrevio: 'No',
            numeroCliente: null,
            observaciones: null,
            
            /* Codigo promocion */
            codigoPromocion: null,
            
            /* Datos Bancarios */
            banco: null,
            cbu: null,
            cbuAlias: null,
            titularCuenta: null,
            titularCuit: null,

            /* Negocio */
            negocio: {
                posicion: null,
                nombreComercial: null,
                razonSocial: null,
                cuit: null,
                pais: null,
                provincia: null,
                localidad: null,
                barrio: null,
                direccion: null,
                codigoPostal: null
            },

            posicionSorteo: 0,

            camposAdicionales: []
        };
        
        state.reinscripcion = false;
        state.validacionIdentidadReinscripcion = [];

        /* Etapas */
        state.etapas = [];

        state.validacionesIdentidad = [];
        state.validacionesParticipacion = [];
        state.transferencias = [];
        /* Para reinscripciones */
        state.validacionIdentidadReinscripcion = [];
        state.imagenes = [];
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento;
    },
    'SET_DATOS' (state, participante) {
        state.participante = {
            /* Datos del participante */
            nombreCompleto: participante.nombreCompleto,
            fechaNacimiento: participante.fechaNacimiento,
            documentoNumero: participante.documentoNumero,
            sexo: participante.sexo,
            pais: participante.pais,
            provincia: participante.provincia,
            localidad: participante.localidad,
            direccion: participante.direccion,
            codigoPostal: participante.codigoPostal,
            numeroCelular: participante.numeroCelular,
            email: participante.email,
            clientePrevio: participante.clientePrevio? 'Si' : 'No',
            numeroCliente: participante.numeroCliente,
            observaciones: participante.observaciones,
            
            /* Codigo promocion */
            codigoPromocion: participante.codigoPromocion,
            
            /* Datos Bancarios */
            banco: participante.banco,
            cbu: participante.cbu,
            cbuAlias: participante.cbuAlias,
            titularCuenta: participante.titularCuenta,
            titularCuit: participante.titularCuit,

            /* Negocio */
            negocio: {
                posicion: participante.negocio? participante.negocio.posicion : null,
                nombreComercial: participante.negocio? participante.negocio.nombreComercial : null,
                razonSocial: participante.negocio? participante.negocio.razonSocial : null,
                cuit: participante.negocio? participante.negocio.cuit : null,
                pais: participante.negocio? participante.negocio.pais : null,
                provincia: participante.negocio? participante.negocio.provincia : null,
                localidad: participante.negocio? participante.negocio.localidad : null,
                barrio: participante.negocio? participante.negocio.barrio : null,
                direccion: participante.negocio? participante.negocio.direccion : null,
                codigoPostal: participante.negocio? participante.negocio.codigoPostal : null
            },

            posicionSorteo: participante.posicionSorteo,

            camposAdicionales: participante.camposAdicionales
        };
       
        state.reinscripcion = (/true/i).test(participante.reinscripcion);
        
        state.validacionIdentidadReinscripcion = [];
        if ((/true/i).test(state.evento.validaIdentidad)) {
            /* Validación en la reinscripcion */
            if (state.reinscripcion) {
                state.validacionIdentidadReinscripcion = 
                {
                    reinscripcion: 'Si',
                    evento: participante.eventoInscripcion,
                    fechaValidacion: participante.fechaValidacion,
                    usuarioValidacion: participante.usuarioValidacion
                }
            }
        }

        /* Etapas */
        state.etapas = participante.participanteEtapas;
    },
    'SET_VALIDACIONES_IDENTIDAD' (state, validaciones) {
        state.validacionesIdentidad = validaciones.map(validacion => ({
            ...validacion,
            detailShowing: false
        }));
    },
    'SET_VALIDACIONES_PARTICIPACION' (state, validaciones) {
        state.validacionesParticipacion = validaciones.map(validacion => ({
            ...validacion,
            detailShowing: false
        }));
    },
    'SET_TRANSFERENCIAS' (state, transferencias) {
        state.transferencias = transferencias.map(transferencia => ({
            ...transferencia,
            detailShowing: false
        }));
    },
    'SET_IMAGENES' (state, imagenes) {
        state.imagenes = imagenes;
    },
    'ADD_IMAGEN' (state, imagen) {
        state.imagenes.push(imagen);
    },
    'REMOVE_IMAGEN' (state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },
    'ADD_EVENTO_ETAPA' (state, participanteEtapa) {
        state.etapas.push(participanteEtapa);
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit, state }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            /* Recuperamos los datos del evento (configuración) */
            apiAxios.get('eventos/' + state.eventoId) 
                .then(res => {
                    commit('SET_EVENTO', res.data);
                    /* Recuperamos los datos del participante */
                    return apiAxios.get('eventos/' + state.eventoId + '/participante/' + state.participanteId);
                })
                .then(res => {
                    commit('SET_DATOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getValidacionesIdentidad: ( { commit, state } ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/validaciones/identidad' ) 
                .then(res => {
                    commit('SET_VALIDACIONES_IDENTIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteValidacionIdentidad ( {}, validacionId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/validaciones/identidad/' + validacionId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getValidacionesParticipacion: ( { commit, state } ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/validaciones/participacion' ) 
                .then(res => {
                    commit('SET_VALIDACIONES_PARTICIPACION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteValidacionParticipacion ( {}, validacionId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/validaciones/participacion/' + validacionId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTransferencias: ( { commit, state } ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/transferencias' ) 
                .then(res => {
                    commit('SET_TRANSFERENCIAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteTransferencia ( {}, transferenciaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/transferencias/' + transferenciaId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    retransferir ( {}, transferenciaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/transferencias/' + transferenciaId + '/add')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getImagenes: ( { commit, state } ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/imagenes' ) 
                .then(res => {
                    commit('SET_IMAGENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addImagen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'jpg' 
                & fileExtension != 'png'
                & fileExtension != 'jpeg'
                & fileExtension != 'pdf') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten imágenes de tipo jpg, png o jpeg.';
            }

            if (fileSize >= 3 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 3MB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);
				formData.append('main', params.main);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/imagenes', formData, options)
                    .then(res => {
                        commit('ADD_IMAGEN', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
    removeImagen ( { commit }, imagenId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.participanteId + '/imagenes/' + imagenId + '/delete')
                .then(() => {
					commit('REMOVE_IMAGEN', imagenId);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addParticipanteEventoEtapa ( { commit }, eventoEtapaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/etapa/' + eventoEtapaId + '/participante/' + state.participanteId)
                .then(res => {
					commit('ADD_EVENTO_ETAPA', res.data);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}